import dayjs from 'dayjs';
import { ProductType } from 'app/shared/model/enumerations/product-type.model';
import { UnitType } from 'app/shared/model/enumerations/unit-type.model';

export interface IDynamicTariff {
  id?: number;
  price?: number | null;
  from?: dayjs.Dayjs | null;
  until?: dayjs.Dayjs | null;
  productType?: keyof typeof ProductType | null;
  unit?: keyof typeof UnitType | null;
}

export const defaultValue: Readonly<IDynamicTariff> = {};
